<template>
<div class="addrList">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleAdd">增加提货点</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.pptype" placeholder="全部类型" class="condition" clearable>
                <el-option v-for="item in pptypeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
            </el-select>
            <el-input v-model="param.key" placeholder="请输入提货点、团长名称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="提货点" class-name="title" min-width="150px"></el-table-column>
            <el-table-column prop="pptypename" label="提货点类型" class-name="center"></el-table-column>
            <el-table-column prop="objrolename " label="所属团长" class-name="center"  min-width="150px">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.objrolelogo" :alt="scope.row.objrolename"
                             preview="videoList"/>
                        <div class="imageText-summary">
                            <div class="textBox">
                                <span>{{scope.row.objrolename ? scope.row.objrolename : '/'}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="address" label="地址" class-name="center" min-width="200px"></el-table-column>
            <el-table-column prop="linkman" label="联系人" class-name="center"></el-table-column>
            <el-table-column prop="linktel" label="电话号码" class-name="center" min-width="100px"></el-table-column>
            <el-table-column prop="statusname" label="状态" class-name="center">
                <template slot-scope="scope">
                    <div :class="status(scope.row.status)">{{scope.row.statusname}}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="160" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn"  v-if="scope.row.status==10 && scope.row.pptype==1">
                            <el-button @click="handleInvate(scope.row)" type="text" size="small">邀请团长</el-button>
                        </span>
                        <span class="separator-btn"  v-if="scope.row.status==1">
                            <el-button @click="handleAuth(scope.row)" type="text" size="small">审核</el-button>
                        </span>
                        <span class="separator-btn" v-if="scope.row.isedit">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </span>
                        <span class="separator-btn" v-if="scope.row.isdelete && scope.row.status!=100">
                            <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
    <addrDialog ref="addrDialog" @getList="refresh"></addrDialog>
    <authAddrDialog ref="authAddrDialog" @getList="_getList"></authAddrDialog>
    <invateLinkDialog ref="invateLinkDialog"></invateLinkDialog>
</div>
</template>

<script>
import {getPickupPointListByHostRole, deletePickupPointInfoByHost} from 'api/brandBusiness'
import Page from 'base/page/page'
import {brandBusiness} from 'api/enumCode'
import {mapGetters, mapActions} from 'vuex'
import AddrDialog from 'views/brandBusiness/systemSetting/addr/components/addrDialog.vue'
import AuthAddrDialog from 'views/brandBusiness/systemSetting/addr/components/authAddrDialog.vue'
import InvateLinkDialog from 'views/brandBusiness/leaderMgt/myLeader/components/invateLinkDialog.vue'
export default {
    name: 'addrList',
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            total: 0,
            pptypeList: brandBusiness.pptype,
            tableData: [],
            power: [],
            param: {
                key: '',
                pptype: '',
                status: ''
            }
        }
    },
    mounted() {
        if (!this.isRefresh) {
            this._getList()
        }
    },
    activated() {
        if (this.isRefresh) {
            if (this.isRefresh === 2) {
                this.param = {
                    key: '',
                    pptype: '',
                    status: ''
                }
                this.setPage({page: 1, pageSize: 10})
            }
            this.$refs.page.handleSizeChange(this.page.page)
            this.setIsRefresh(0)
        }
    },
    methods: {
        refresh() {
            if (this.isRefresh === 2) {
                this.param = {
                    key: '',
                    pptype: '',
                    status: ''
                }
                this.setPage({page: 1, pageSize: 10})
            }
            this.$refs.page.handleSizeChange(this.page.page)
        },
        handleInvate(row) {
            this.$refs.invateLinkDialog.openDialog(row.inviteurlurl)
        },
        handleAuth(row) {
            this.$refs.authAddrDialog.openDialog(row)
        },
        handleAdd() {
            this.$refs.addrDialog.openDialog()
        },
        handleEdit(row) {
            this.$refs.addrDialog.openDialog(row)
        },
        handleDel(row) {
            this.$confirm('确认删除该提货点', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._del(row)
            })
        },
        handleQuery() {
            this.setParams(this._.cloneDeep(this.param))
            this.$refs.page.handleSizeChange(1)
        },
        _del(obj) {
            this.setLoading(true)
            deletePickupPointInfoByHost({
                data: Object.assign({}, {ppinnerid: obj.ppinnerid}),
                success: data => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getPickupPointListByHostRole({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams',
            'setIsRefresh',
            'setPage'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        status () {
            return function(value) {
                for (let i = 0; i < brandBusiness.addrStatus.length; i++) {
                    if (value === brandBusiness.addrStatus[i].code) {
                        return brandBusiness.addrStatus[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters(['page', 'user', 'isRefresh'])
    },
    components: {
        Page, AddrDialog, AuthAddrDialog, InvateLinkDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.addrList {

    .imageText {
        .img {
            min-width: 60px;
            width: 60px;
            height: 60px;
            margin-right: 16px;
        }
    }
}
</style>
